import { OnInit, AfterViewInit, Component } from "@angular/core";
import { Observable } from "rxjs";
import { WellsModel } from "../../../../models/wells.model";
import { GraphService } from "../../../../services/graphs.service";
import { GridOptions } from "ag-grid-community";
import { TargetCellRenderer } from "./target-cell-renderer.component";
import "ag-grid-enterprise";
import { OpsExplorationAndDrillingMilestonesModel } from "../../../../models/graphs.model";
import { GlobalService } from "../../../../services/global.service";
import { MessageService } from "../../../../services/message.service";

@Component({
  selector: 'app-ops-exploration_wells',
  templateUrl: './explorationWells.component.html',
  styleUrls: ['../../home/home.component.scss']
})

export class ExplorationWellsComponent implements OnInit, AfterViewInit {

  graphService: Observable<any>;
  wellService: Observable<any>;
  wellData: WellsModel[];
  public gridOptions: GridOptions;

  private gridApi;
  private gridColumnApi;
  rowSelection;
  frameworkComponents;
  columnDefs;
  rowData;
  defaultColDef;
  newWellData: any;
  newAddedData = [];
  removedData = [];
  updatedCellData = [];

  constructor(public globals: GlobalService,
    private graph: GraphService,
    private messageService: MessageService) {

    this.columnDefs = [
      {
        headerName: '#',
        width: 30,
        checkboxSelection: true,
        sortable: false,
        suppressMenu: true,
      },
      {
        headerName: 'Target',
        field: 'target',
        width: 80,
        rowDrag: true,
        cellRenderer: 'targetCellRenderer',
        cellEditor: 'agRichSelectCellEditor',
        cellEditorParams: {
          cellRenderer: 'targetCellRenderer',
          values: ["Oil", "Gas", "OilGas"]
        },
      },
      { headerName: 'Well Name', field: 'wellName', width: 150 },
      { headerName: 'Well Type', field: 'wellType', width: 150 },
      { headerName: 'Basin', field: 'basin', width: 150 },
      {
        headerName: 'Status',
        field: 'status',
        width: 150,
        // cellEditor: 'agRichSelectCellEditor',
        // cellEditorParams: {
        //   cellHeight: 50,
        //   values: ["C&S, successful", "Drilling", "P&A", "P&A, successful" ]
        // },
      },
    ];

    this.rowSelection = "multiple";
    this.frameworkComponents = { targetCellRenderer: TargetCellRenderer };
    this.defaultColDef = {
      editable: true,
      resizable: true
    };
  }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    this.load();
  }

  load() {

    this.wellService = this.graph.getWells();
    this.wellService.subscribe(data => {
      this.wellData = data.contents;
      this.rowData = this.wellData;
    });
  }

  onAddRow() {
    var newItem = this.createNewRowData();
    var res = this.gridApi.updateRowData({ add: [newItem], addIndex: 0 });
    this.printResult(res);
  }

  createNewRowData() {
    var newData = {
      target: "",
      wellName: "",
      wellType: "",
      basin: "",
      status: ""
    };
    return newData;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  }

  printResult(res) {

    if (res.add) {
      res.add.forEach(function (rowNode) {
      });
    }
    if (res.remove) {
      res.remove.forEach(function (rowNode) {
      });
    }
    if (res.update) {
      res.update.forEach(function (rowNode) {
      });
    }
  }

  onRemoveSelected() {

    var selectedData = this.gridApi.getSelectedRows();
    var res = this.gridApi.updateRowData({ remove: selectedData });
    this.printResult(res);
  }

  getAllRows() {

    let rowData = [];
    this.gridApi.forEachNode(node => rowData.push(node.data));
    return rowData;
  }

  onCellEditingStopped(params) {

    this.updatedCellData.push(params.data);
  }

  saveOpsExplorationAndDrillingMilestonesData() {

    let opsExplorationAndDrillingMilestonesModel: OpsExplorationAndDrillingMilestonesModel = new OpsExplorationAndDrillingMilestonesModel();
    this.newWellData = this.getAllRows();

    let jsonObject: any = JSON.stringify(this.newWellData);
    this.graph.postOpsExplorationAndDrillingMilestones(jsonObject).subscribe(r => {
      this.graphService = r;
      this.wellService.subscribe(data => {
        this.wellData = data.contents;
        this.rowData = this.wellData;
        this.gridApi.refreshCells();
      });
    });
  }
}